export const GLOBAL_STORE_NAME = "global";
export const OFFICE_EVENTS_STORE_NAME = "officeEvents";
export const QR_GENERATOR_STORE_NAME = "qr-generator";
export const OFFICE_ROLES_STORE_NAME = "officeRoles";
export const OFFICE_EQUIPMENT_STORE_NAME = "officeEquipment";
